export const FilterNodeIcon = () => {
  return (
    <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
      <path clipRule="evenodd" d="M17 3C17 2.44772 16.5523 2 16 2H4C3.44771 2 3 2.44772 3 3V6C3 6.26522 3.10536 6.51957 3.29289 6.70711L8 11.4142V15C8 15.2652 8.10536 15.5196 8.29289 15.7071L10.2929 17.7071C10.5789 17.9931 11.009 18.0787 11.3827 17.9239C11.7564 17.7691 12 17.4045 12 17V11.4142L16.7071 6.70711C16.8946 6.51957 17 6.26522 17 6V3Z" fill="#139E60" fillRule="evenodd" />
    </svg>
  );
};
